'use client';

import useSWR from 'swr';

import { useLocale, useTranslations } from 'next-intl';
import { PRODUCT_LISTS } from '@/utils/gtm/item-lists';
import RelatedProducts from '../related-products';
import { getAmastyProductsBySkus } from '@/services/elasticsearch/getProducts';
import useGetProductsBySkus from '@/hooks/product/useGetProductsBySkus';

const RelatedProductsWrapper = ({ productSku }) => {
  const t = useTranslations('product');
  const locale = useLocale();

  const { data: skus } = useSWR(
    productSku ? `amasty-related-${locale}-${productSku}` : null,
    () => getAmastyProductsBySkus(productSku, locale),
    {
      revalidateOnFocus: false,
    }
  );

  const relatedSkus = skus?.data?.data?.[0]?.related;
  const crossSellSkus = skus?.data?.data?.[0]?.crosssel;
  const upSellSkus = skus?.data?.data?.[0]?.upsell;

  const [relatedProducts] = useGetProductsBySkus(relatedSkus);

  const [crossSellProducts] = useGetProductsBySkus(crossSellSkus);

  const [upSellProducts] = useGetProductsBySkus(upSellSkus);

  return (
    <div className='mt-4'>
      {[
        {
          products: relatedProducts,
          title: t('related_products_key'),
          list: PRODUCT_LISTS.pdpRelated,
        },
        {
          products: upSellProducts,
          title: t('up_sell_products_key'),
          list: PRODUCT_LISTS.pdpUpSell,
        },
        {
          products: crossSellProducts,
          title: t('also_viewed_key'),
          list: PRODUCT_LISTS.pdpAlsoViewed,
        },
      ]?.map((item, key) => (
        <RelatedProducts
          key={key}
          isLoading={false}
          relatedProducts={item?.products}
          title={item?.title}
          list={item?.list}
        />
      ))}
    </div>
  );
};

export default RelatedProductsWrapper;
